module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-collector-3.3d440c03.svg";